/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { ReactComponent as Logo } from "./../../assets/images/logo/Logo.svg";
import { Link } from "react-router-dom";
import { routes } from "../../appRoutingHelpers";

const pageWrapper = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: absolute;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${colors.white};
  inset: 0px 0px 0px 0px;
`;

const linkStyle = css`
  display: inline-block;
  text-decoration: none !important;
  color: ${colors.ctaMain} !important;
  &:hover {
    color: ${colors.ctaSecondaryOne} !important;
  }
`;

export const NotFound = () => {
  return (
    <div css={pageWrapper}>
      <Logo />
      <StyledText className="headerOne mb-0" color={colors.textPrimary}>
        Page not found!
      </StyledText>
      <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
        Sorry, but the page you were looking for could not be found.
      </StyledText>
      <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
        You can{" "}
        <span>
          <Link css={linkStyle} to={routes.home()}>
            return to our front page
          </Link>
        </span>
        , or contact support if you can't find what you're looking for.
      </StyledText>
    </div>
  );
};
